<template>
  <span>
    <v-form>
      <v-card flat max-width="1000">
        <v-card-text class="pb-0">
          <v-form ref="detailsDocumentsTypeForm">
            <v-select
                v-model="data.doc_customer_type_id"
                :items="customerTypes"
                item-text="customer_type_name"
                item-value="customer_type_id"
                :rules="[rules.typeReguired]"
                label="Тип абонента"
                @change="customerTypeChanged()"
                required
            >
            </v-select>
            <v-text-field v-model="data.doc_type_name" label="Наименование типа заявки" :rules="[rules.reguired]"></v-text-field>
            <v-text-field v-model="data.expired_in_days" type="number" label="Число дней до ответа" :rules="[rules.reguired]"></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-text class="pt-0">
          <v-list>
            <v-subheader>
              <v-row><p class="mt-2">Требуемые документы</p> <v-btn icon @click="addRequired"><v-icon>add</v-icon></v-btn>
              </v-row>
            </v-subheader>
            <v-list-item-group color="primary">
              <v-list-item
                  v-for="(requiredFile, index) in requiredFiles"
                  :key="index"
              >
                <v-list-item-content class="pt-0 pb-0">
                  <v-row no-gutters>
                    <v-col cols="11">
                      <v-select
                          v-model="requiredFile.doc_required_file_id"
                          :items="requiredFilesList"
                          item-text="doc_required_file_name"
                          item-value="doc_required_file_id"
                          label="Требуемый документ"
                          class="text-none"
                      >
                      </v-select>
                    </v-col>
                    <v-col cols="1">
                      <v-btn class="mt-4" title="Убрать файл" icon @click="removeRequiredFile(index)"><v-icon>remove</v-icon></v-btn>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-btn
              color="success"
              class="mr-4"
              @click="save"
          >
            Сохранить
          </v-btn>
          <v-btn
              class="mr-4"
              @click="$emit('close')"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </span>
</template>

<script>
export default {
  name: 'DocumentsRequestsTypeDetails',
  props: {
    data: {}
  },
  data () {
    return {
      rules: {
        reguired: v => !!v || 'Заполните это поле!',
        typeReguired: v => !!v || 'Необходимо выбрать тип абонента'
      },
      requiredFilesList: [],
      requiredFiles: [],
      customerType: {},
      customerTypes: [
        { customer_type_id: 1, customer_type_name: 'Физическое лицо' },
        { customer_type_id: 2, customer_type_name: 'Индивидуальный предприниматель' },
        { customer_type_id: 3, customer_type_name: 'Юридическое лицо' }
      ]
    }
  },
  mounted () {
    this.getRequiredFiles()
    this.getDocumentRequiredFiles()
  },
  methods: {
    getRequiredFiles () {
      this.axios.get(`/api/document_required_file/`).then((response) => {
        this.requiredFilesList = response.data.results
      }).catch((err) => {
        console.log(err)
      })
    },
    getDocumentRequiredFiles () {
      if (this.data.doc_type_id != null) {
        this.axios.get(`/api/document_required_file/?document_type=${this.data.doc_type_id}`).then((response) => {
          this.requiredFiles = response.data.results
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    save () {
      if (this.$refs.detailsDocumentsTypeForm.validate()) {
        if (this.data.doc_type_id === null) {
          this.axios.post('/api/document_type/', this.data).then((response) => {
            const reqFiles = { doc_type_id: response.data.doc_type_id, required_files: this.requiredFiles }
            this.axios.post('/api/document_required_file_link/', reqFiles).then(() => {
              this.$emit('close')
            }).catch((err) => {
              console.log(err)
              this.loading = false
            })
          }).catch((err) => {
            console.log(err)
            this.loading = false
          })
        } else {
          this.axios.patch(`/api/document_type/${this.data.doc_type_id}/`, this.data).then((response) => {
            const reqFiles = { doc_type_id: response.data.doc_type_id, required_files: this.requiredFiles }
            this.axios.post('/api/document_required_file_link/', reqFiles).then(() => {
              this.$emit('close')
            }).catch((err) => {
              console.log(err)
              this.loading = false
            })
          }).catch((err) => {
            console.log(err)
            this.loading = false
          })
        }
      }
    },
    customerTypeChanged () {
      console.log('')
    },
    addRequired () {
      this.requiredFiles.push({ doc_required_file_id: null })
    },
    removeRequiredFile (index) {
      this.requiredFiles.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .v-list-item__title {
    white-space: normal;
  }
  /deep/ .v-select__selection--comma {
    white-space: normal;
  }
</style>



// WEBPACK FOOTER //
// src/spa/documents-requests/DocumentsRequestsTypeDetails.vue